var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLogged)?_c('navbar'):_vm._e(),(_vm.isLogged)?_c('main-sidebar'):_vm._e(),_c('main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }